import React from "react";

function Certification({ teacher_certificate }) {
  if (teacher_certificate) {
    return (
      <div
        className="tab-pane"
        id="certifications"
        role="tabpanel"
        aria-labelledby="certifications-tab"
      >
        <div className="row">
          <div className="col-6 col-md-3">
            <p>
              {teacher_certificate?.start_study_year} —{" "}
              {teacher_certificate?.end_study_year}
            </p>
          </div>
          <div className="col-12 col-md-9">
            <p>
              {teacher_certificate?.issue_by} {teacher_certificate?.certificate}
            </p>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div
        className="tab-pane"
        id="certifications"
        role="tabpanel"
        aria-labelledby="certifications-tab"
      >
        <div className="row">
          <p>No data on certificate</p>
        </div>
      </div>
    );
  }
}

export default Certification;
